import { render, staticRenderFns } from "./remarkModal.vue?vue&type=template&id=126e4fa4&scoped=true"
import script from "./remarkModal.vue?vue&type=script&lang=js"
export * from "./remarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e4fa4",
  null
  
)

export default component.exports